// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__8Prwq","legacyBtn":"MutateMid_legacyBtn__iurMR"};